import { EditTheme } from "./edit-theme";

export default EditTheme;
